import React from 'react';
import '../css/MenuItem.css';

const MenuItem = ({ item, isActive, isCollapsed, onClick }) => {
  const handleClick = () => {
    onClick(item.id);
  };

  return (
    <div className="menu-item-container">
      <div
        className={`menu-item ${isActive ? 'active' : ''} ${isCollapsed ? 'collapsed' : ''}`}
        onClick={handleClick}
      >
        <div className="menu-item-content">
          <img src={item.icon_src} alt={item.label} className="menu-icon"/>
          {!isCollapsed && (
            <>
              <span className="menu-label">{item.label}</span>
              {item.hasDropdown && (
                <span className={`dropdown-arrow ${isActive ? 'rotated' : ''}`}>
                  ›
                </span>
              )}
            </>
          )}
        </div>
      </div>

      {item.hasDropdown && !isCollapsed && (
        <div className={`dropdown-menu ${isActive ? 'open' : ''}`}>
          {item.subItems.map((subItem, index) => (
            <div key={index} className="dropdown-item">
              <span className="dropdown-bullet">•</span>
              <span className="dropdown-label">{subItem}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MenuItem;